export enum ProjectProfileTab {
  Overview,
  Settings,
  Delete,
  Activity,
  Access
}
